module.exports = __webpack_public_path__ + "img/sppr_0603.2756d57e.jpg";